import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { IProfile, IResponse } from '@interfaces/index';
import { AppService } from '@ui-components/services';
import { forkJoin, switchMap } from 'rxjs';
import { ProfileService } from '../../services/profile.service';
import { IQuestion } from 'projects/ui-components/src/interfaces/IProfile';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrl: './personal.component.scss'
})
export class PersonalComponent {

  form: FormGroup;
  loading = false;
  profile: IProfile | null = null;
  personal: IQuestion[] = [];
  person_id: number | undefined;
  consent = false;
  confirming_withdrawal = false;
  error = '';

  constructor(
    protected _app_service: AppService,
    protected _profile_service: ProfileService,
    protected _fb: FormBuilder,
    protected _route: ActivatedRoute,
    public router: Router
  ) {
    this.form = this._fb.group({
      answers: this._fb.array([])
    });
  }

  ngOnInit() {

    this._app_service.getProfile().pipe(
      switchMap(
        (response: IResponse<IProfile>) => {
          this.profile = response.data;
          const person_id_param = this._route.snapshot.paramMap.get('person_id');
          this.person_id = person_id_param ? +person_id_param : undefined;
          return forkJoin({
            personal: this._profile_service.getPersonal(this.person_id),
            consent: this._profile_service.getPersonalConsent(this.person_id)
          });
        }
      )
    ).subscribe(
      ({ personal, consent }) => {
        this.personal = personal.data;
        this.personal.forEach(question => {
          this.answers.push(this._fb.group({
            question_id: [question.question_id],
            answer_id: [question.answer?.answer_id || '',  Validators.required]
          }))
        })
        // Applied once the controls exist, so none are added enabled after the form is disabled.
        this.setConsentState(!!consent.data?.consent);
      }
    )
  }

  get answers() {
    return this.form.get('answers') as FormArray;
  }
 
  /** Without consent the answers can neither be edited nor saved. */
  private setConsentState(consent: boolean) {
    this.consent = consent;
    consent ? this.form.enable() : this.form.disable();
  }

  setConsent(consent: boolean) {
    this.error = '';
    const failed = () => this.error = 'Your choice could not be saved. Please try again.';
    this._profile_service.updatePersonalConsent(consent).subscribe({
      next: (response) => {
        if (response.code && response.code !== 200) {
          failed();
          return;
        }
        this.setConsentState(consent);
        this.confirming_withdrawal = false;
        if (!consent) {
          // withdrawing deletes the stored answers
          this.answers.controls.forEach(group => group.get('answer_id')?.setValue(''));
        }
      },
      error: failed
    });
  }

  // The response carries no questions, so `personal` is left as loaded.
  update(){
    this.error = '';
    const failed = () => this.error = 'Your answers could not be saved. Please try again.';
    this._profile_service.updatePersonal(this.form.get('answers')?.value, this.person_id).subscribe({
      next: (response) => {
        if (response.code && response.code !== 200) {
          failed();
        }
      },
      error: failed
    });
  }


}
